<template>
  <GChart
    :settings="{ packages: ['corechart'], language: 'nl-nl' }"
    :data="rows"
    :options="options"
    type="ComboChart"
  />
</template>

<script>
import { find } from 'lodash-es';

export default {
  name: 'ProjectWidget',
  data() {
    return {
      show: false,
      options: {
        backgroundColor: {
          fillOpacity: 0,
        },
        height: this.height,
        width: this.width,
        colors: JSON.parse(JSON.stringify(this.$store.state.colorScheme)),
        legend: { position: 'none' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 25,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          format: 'yyyy',
          textStyle: { fontSize: 13 },
          gridlines: { color: '#eee' },
        },
        vAxis: {
          // format: '\'€\' ',
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: {
            type: 'line',
            color: '#67bf00',
          },
          1: {
            type: 'line',
            color: '#000066',
            annotations: {
              stem: {
                color: 'green',
              },
              textStyle: {
                color: 'black',
                auraColor: '#f7f8fa',
              },
              stemLength: 30,
            },
          },
          2: {
            type: 'line', color: '#c1272d',
          },
          3: {
            type: 'line', areaOpacity: 0, color: 'green', lineWidth: 1,
          },
        },
        annotations: {
          stem: {
            color: 'black',
          },
          stemLength: Number(this.height) - 50,
        },
      },
    };
  },
  props: {
    doel: String,
    targetDate: Date,
    looptijd: String,
    projection: Array,
    height: {
      type: String,
      default: '250',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    rows() {
      return this.getRows();
    },
    columns() {
      return this.getCols();
    },
    currentPort() {
      return find(this.$store.state.ports, {
        id: this.$store.state.currentPort,
      });
    },
  },
  methods: {
    getCols() {
      const cols = [];
      cols.push({
        type: 'date',
        label: 'Datum',
      });
      cols.push({
        type: 'string',
        role: 'annotation',
      });
      cols.push({
        type: 'number',
        label: 'Goed',
      });
      cols.push({
        type: 'number',
        label: 'Normaal',
      });
      cols.push({
        type: 'string',
        role: 'annotation',
      });
      cols.push({
        type: 'number',
        label: 'Slecht',
      });
      if (Number(this.doel) !== 0) {
        cols.push({
          type: 'number',
          label: 'Doelwaarde',
        });
      }
      return cols;
    },
    getRows() {
      const d = new Date();
      const year = d.getFullYear();
      const month = d.getMonth();
      const day = d.getDate();
      let c;
      if (this.targetDate) {
        c = new Date(this.targetDate);
      } else {
        c = new Date(year + Number(this.looptijd), month, day);
      }

      let targetDate = false;
      let goalDate = false;
      const rows = [];
      rows.push(this.getCols());
      const pvvidata = this.projection;
      if (pvvidata.length > 0) {
        this.options.hAxis.ticks = [];
        const datesArray = [];
        for (let i = 0; i < pvvidata.length; i += 1) {
          const iDate = pvvidata[i].Date.split('-')[0];
          if (i === 0) {
            datesArray.push(new Date(pvvidata[i].Date));
          } else if (datesArray[datesArray.length - 1].getFullYear() !== Number(iDate)) {
            datesArray.push(new Date(iDate, 0, 1));
          }
        }
        this.options.hAxis.ticks = datesArray;
      }
      if (pvvidata && Object.keys(pvvidata).length !== 0) {
        let good = true;
        let normal = true;
        let bad = true;
        for (let key = 0; key < pvvidata.length; key += 1) {
          const satDate = new Date(pvvidata[key].DateJS);
          let rowItem;
          if (good && pvvidata[key].vG <= 0) {
            pvvidata[key].vG = 0;
            good = false;
          } else if (pvvidata[key].vG <= 0) {
            pvvidata[key].vG = null;
          }
          if (normal && pvvidata[key].vN <= 0) {
            pvvidata[key].vN = 0;
            normal = false;
          } else if (pvvidata[key].vN <= 0) {
            pvvidata[key].vN = null;
          }
          if (bad && pvvidata[key].vB <= 0) {
            pvvidata[key].vB = 0;
            bad = false;
          } else if (pvvidata[key].vB <= 0) {
            pvvidata[key].vB = null;
          }

          if (!targetDate && satDate > c) {
            targetDate = true;
            rowItem = [
              satDate,
              'Doeldatum',
              pvvidata[key].vG,
              pvvidata[key].vN,
              null,
              pvvidata[key].vB,
            ];
          } else if (
            !goalDate
            && Number(this.doel) > 0
            && pvvidata[key].vN > Number(this.doel)
          ) {
            goalDate = true;
            rowItem = [
              satDate,
              null,
              pvvidata[key].vG,
              pvvidata[key].vN,
              'Doel bereikt',
              pvvidata[key].vB,
            ];
          } else {
            rowItem = [
              satDate,
              null,
              pvvidata[key].vG,
              pvvidata[key].vN,
              null,
              pvvidata[key].vB,
            ];
          }

          if (Number(this.doel) !== 0) {
            rowItem.push(Number(this.doel).toFixed(2));
          }
          rows.push(rowItem);
        }
      }
      return rows;
    },
  },
};
</script>
